import { Component, OnInit } from '@angular/core';
import { NgbActiveModal,NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators,ReactiveFormsModule } from '@angular/forms';
import {AuthServiceService} from '../../../shareModule/services/auth-service.service';
import {LocalServiceService} from '../../../shareModule/services/local-service.service';
import {Router} from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { isInteger } from '@ng-bootstrap/ng-bootstrap/util/util';
import { SearchCountryField, CountryISO } from 'ngx-intl-tel-input';
import Swal from 'sweetalert2'
import { timers } from 'jquery';


@Component({
  selector: 'app-member-signup-modal',
  templateUrl: './member-signup-modal.component.html',
  styleUrls: ['./member-signup-modal.component.scss']
})
export class MemberSignupModalComponent implements OnInit {

  memberSignUp: FormGroup;
  submitted=false;
  error = "";
  gallery = [];
  urls=[];
  myFiles:string [] = [];
  filesAmount:any;
  message:any;
  imagePathProduct:any;
  clicked = false;
  phone:any;
  isFileUploaded= false;
  imagePath:any;
  selectedFile:any;
  recieptImage:any="../../../../assets/images/clip.png";
  excelImage = "../../../../assets/images/exc.png";
  pdfImage = "../../../../assets/images/pd.png";
  docImage = "../../../../assets/images/doc.jpg";
  separateDialCode = false;
  SearchCountryField = SearchCountryField;
	// TooltipLabel = TooltipLabel;
	CountryISO = CountryISO;
	preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  customPlaceholderValue = "9999 9999";

  constructor(public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private local :LocalServiceService,
    private router:Router,
    private formBuilder: FormBuilder,
    private auth:AuthServiceService,) { } 

  ngOnInit(): void {

    this.memberSignUp = this.formBuilder.group({
      usersName: ['', [Validators.required]],
      email: ['', [Validators.required,Validators.email]],
      position: [''],
      noYear: [''],
      lastComp: [''],
    });
  }
  changePreferredCountries() {
		this.preferredCountries = [CountryISO.India, CountryISO.Canada];
	}

  get memUp(){
    return this.memberSignUp.controls;
  }

  memberSinup(){
    this.submitted = true;
    if(this.memberSignUp.invalid){
      return;
    }

    if(this.phone == undefined){
      this.toastr.error('Please enter phone number');
      return;
    }

    if(this.phone.countryCode == ""){
      this.toastr.error('Please select country code');
      return;
    }


    const formData = new FormData();

    formData.append('name',this.memUp.usersName.value);
    formData.append('dial_code',this.phone.dialCode);
    formData.append('phone_number',this.phone.number);
    formData.append('email',this.memUp.email.value);
    formData.append('position',this.memUp.position.value);
    formData.append('noOfYears',this.memUp.noYear.value);
    formData.append('lastPosition',this.memUp.lastComp.value);

    for (var i = 0; i < this.myFiles.length; i++) { 
      formData.append("file", this.myFiles[i]);
    }


    // let data = { 'name': this.memUp.usersName.value, 'dial_code': this.phone.dialCode, 'phone_number': this.phone.number,'email':this.memUp.email.value,'file':this.selectedFile };

    this.clicked = true;  //button disabled

    this.auth.member_signUp(formData).subscribe((response:any)=>{
      this.toastr.success(response.message);

      // Swal.fire({
      //   title: 'Do you want to send welcome message to customer',
      //   showCancelButton: true,
      //   confirmButtonColor: '#3085d6',
      //   cancelButtonColor: '#d33',
      //   confirmButtonText: 'Yes, Send it!'
      // }).then((result) => {
      //   if (result.isConfirmed) {
      //     /*code to be send */

      //     let data = {'userId':response.body.userId,'dial_code':response.body.dial_code,'phone_number':response.body.phone_number,'status':'1'};

      //     this.auth.send_member_signUp_message(data).subscribe((response:any)=>{
      //       Swal.fire(
      //         'Success!',
      //         'Your welcome message sent.',
      //         'success'
      //       );
      //     },(e)=>{
      //       if(e.status == 401){
      //         this.local.logout();
      //         this.router.navigate(['/']);
      //       }else{
      //         this.toastr.error(e.error.message);
      //       }
      //     })


      //   }
      // })
      // this.router.navigate(['/customer'],{queryParams:{uid:this.phone.number}});
      this.modalService.dismissAll();
      window.location.reload();
      this.memberSignUp.reset();
      this.phone = undefined;
    }, (e) => {
        this.clicked = false;
      if(e.status == 401){
        this.local.logout();
        this.router.navigate(['/admin']);
      }else{
        this.toastr.error(e.error.message);
      }
    })

    // console.log('----------->',this.phone);
  }

  dismiss(){
    this.modalService.dismissAll();
  }

  // onFileSelected(files)
  // {
  //   console.log(files);
  //   if (files.length === 0) {
  //     return;
  //   }

  //   const mimeType = files[0].type;
  //   // console.log("=========mime",mimeType);

  //   if(mimeType == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'){
  //       this.recieptImage = this.docImage;
  //   }else if(mimeType == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
  //     this.recieptImage = this.excelImage;
  //   }else if(mimeType == 'application/pdf'){
  //     this.recieptImage = this.pdfImage;
  //   }

  //   const reader = new FileReader();
  //   this.imagePath = files;
  //   this.selectedFile = <File>files[0];
  //   console.log(this.selectedFile,"==============")
  //   reader.readAsDataURL(files[0]);
  //   // reader.onload = (_event) => {
  //   //   console.log("----------",_event);
  //   //   this.recieptImage = reader.result;
  //   //   // this.profileImg = reader.result;
  //   // };


  //   // this.selectedFile = event.target.files[0];
  // }

  onFileSelected(event) {
    this.urls=[];
    this.myFiles=[];
    this.isFileUploaded =true;
    this.filesAmount = event.target.files.length;

    // console.log(this.filesAmount);
    if(this.filesAmount <= 4){

    if (event.target.files && event.target.files[0]) {


      for(let i = 0; i < this.filesAmount ; i++){
          if(event.target.files[i].type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'){
            this.urls.push(this.docImage);
          }else if(event.target.files[i].type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
            this.urls.push(this.excelImage);
          }else if(event.target.files[i].type == 'application/pdf'){
            this.urls.push(this.pdfImage);
          }
      }
    
    const reader = new FileReader();

    this.gallery.push(<File>event.target.files);

    this.imagePathProduct = event.target.files;

        for (let i = 0; i < this.filesAmount; i++) {
                let read = new FileReader();
          
                this.myFiles.push(event.target.files[i]); 
              

                read.readAsDataURL(event.target.files[i]);
        }
    }
    }
    else{
      Swal.fire('Sorry cannot upload more than four files');
    }
  }



}
